import {
    ADD, DECREASE, REMOVE,
} from "./actionTypes";

export const addToCart = (prodcutId) => {
    return {
        type: ADD,
        payload: prodcutId,
    };
};

export const decreaseFromCart = (prodcutId) => {
    return {
        type: DECREASE,
        payload: prodcutId,
    }
}

export const deleteFromCart = (prodcutId) => {
    return {
        type: REMOVE,
        payload: prodcutId,
    };
};
